import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const ErrorLog = () => {
  const { t } = useTranslation();
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    // Fetch from API or use mock data
    setLogs([
      {
        time: "2025-05-26 10:15",
        level: "error",
        message: "Payment gateway timeout",
      },
      {
        time: "2025-05-25 17:45",
        level: "warning",
        message: "Low memory usage",
      },
    ]);
  }, []);

  return (
    <div>
      <h4>
        {t("errors")} {t("logs")}
      </h4>
      <ul>
        {logs.map((log, index) => (
          <li key={index}>
            <strong>{log.time}</strong> -{" "}
            <span className={log.level}>{log.level.toUpperCase()}</span> —{" "}
            {log.message}
          </li> 
        ))}
      </ul>
    </div>
  );
};

export default ErrorLog;
